export class NormalGameController {
  static calculateScores = (
    value,
    multiple,
    currentRound,
    players,
    scoreMultiplier,
    scoreTotal
  ) => {
    const { player: currentPlayer } = currentRound;
    currentRound.currentScore =
      players[currentPlayer].currentScore - scoreTotal;
      currentRound.total = scoreTotal + currentRound.total;
    return {
      currentRound,
      scoreMultiplier: scoreMultiplier !== multiple ? multiple : 1,
      players,
      scoreTotal,
    };
  };

  static isWinner(updatedPlayers, updatedPlayer) {
    
  }
}
